import { lazy } from 'react';

// ========================================
// LAZY LOADED COMPONENTS & PAGES
// Zentrale Datei für alle lazy imports
// ========================================

// Homepage Components
export const HeroSection = lazy(() => import('../components/HeroSection'));
export const TrustBar = lazy(() => import('../components/TrustBar'));
export const DreiHauptFlaechen = lazy(() => import('../components/DreiHauptFlaechen'));
export const ServicesOverview = lazy(() => import('../components/ServicesOverview'));
export const LeadFormWizard = lazy(() => import('../components/LeadFormWizard'));

// Main Pages
export const SchweinestallVerkaufenPage = lazy(() => import('../pages/SchweinestallVerkaufenPage'));
export const OekopunkteVerkaufenPage = lazy(() => import('../pages/OekopunkteVerkaufenPage'));
export const ServicesPage = lazy(() => import('../pages/ServicesPage'));
export const EinzugsgebietPage = lazy(() => import('../pages/EinzugsgebietPage'));


export const SuchprofilPage = lazy(() => import('../pages/SuchprofilPage'));
export const ImpressumPage = lazy(() => import('../pages/ImpressumPage'));
export const DatenschutzPage = lazy(() => import('../pages/DatenschutzPage'));
export const KontaktPage = lazy(() => import('../pages/KontaktPage'));
export const WiderrufPage = lazy(() => import('../pages/WiderrufPage'));
export const NotFoundPage = lazy(() => import('../pages/NotFoundPage'));
export const ErbenRechnerPage = lazy(() => import('../pages/ErbenRechnerPage'));

// Property Type Pages
export const AckerlandPage = lazy(() => import('../pages/AckerlandPage'));
export const WaldPage = lazy(() => import('../pages/WaldPage'));
export const GruenlandPage = lazy(() => import('../pages/GruenlandPage'));
export const SonderkulturenPage = lazy(() => import('../pages/SonderkulturenPage'));
export const HofstellenPage = lazy(() => import('../pages/HofstellenPage'));
export const RinderstallVerkaufenPage = lazy(() => import('../pages/RinderstallVerkaufenPage'));
export const HofMitFlaechenPage = lazy(() => import('../pages/HofMitFlaechenPage'));
export const BauernhoefePage = lazy(() => import('../pages/BauernhoefePage'));

// Admin & Management Pages
export const AdminPage = lazy(() => import('../pages/AdminPage'));
export const ConfirmationPage = lazy(() => import('../pages/ConfirmationPage'));
export const ProfileConfirmedPage = lazy(() => import('../pages/ProfileConfirmedPage'));
export const ProfileManagementPage = lazy(() => import('../pages/ProfileManagementPage'));
export const UnsubscribeSuccessPage = lazy(() => import('../pages/UnsubscribeSuccessPage'));
export const BestaetigungAbgelaufenPage = lazy(() => import('../pages/BestaetigungAbgelaufenPage'));

// Feature Pages
export const KaeuferRadarPage = lazy(() => import('../pages/KaeuferRadarPage'));
export const BewertungBestaetigung = lazy(() => import('../pages/BewertungBestaetigung'));
export const VerkaufenAgrarflaechenPage = lazy(() => import('../pages/VerkaufenAgrarflaechenPage'));
export const NewsletterBestaetigung = lazy(() => import('../pages/NewsletterBestaetigung'));
export const NewsletterPage = lazy(() => import('../pages/NewsletterPageStyled'));
export const KIAssistentPage = lazy(() => import('../pages/KIAssistentPage'));
export const FlaechenbewertungPage = lazy(() => import('../pages/FlaechenbewertungPage'));
export const ImmobilienPage = lazy(() => import('../pages/ImmobilienPage'));
export const MeineGebotePage = lazy(() => import('../pages/MeineGebotePage'));
export const PropertyDetailPage = lazy(() => import('../pages/PropertyDetailPage'));

// Landkreis Pages
export const LandkreisPage = lazy(() => import('../pages/LandkreisPage'));
export const LandkreisDetailPage = lazy(() => import('../pages/LandkreisDetailPage'));
export const LandkreisUebersichtPage = lazy(() => import('../pages/LandkreisUebersichtPage'));

// Content & Information Pages
export const ContentPreviewPage = lazy(() => import('../pages/ContentPreviewPage'));
export const LeistungenPage = lazy(() => import('../pages/LeistungenPage'));
export const AngebotePage = lazy(() => import('../pages/AngebotePage'));
export const RatgeberPage = lazy(() => import('../pages/RatgeberPageNew'));
export const RatgeberLexikonPage = lazy(() => import('../pages/RatgeberLexikonPage'));
export const RatgeberVideosPage = lazy(() => import('../pages/RatgeberVideosPage'));
export const RatgeberArtikelListPage = lazy(() => import('../pages/RatgeberArtikelListPage'));
export const RatgeberDownloadsPage = lazy(() => import('../pages/RatgeberDownloadsPage'));
export const RatgeberArtikelPage = lazy(() => import('../pages/RatgeberArtikelPage'));

// Content-Seiten - Agrarflächen verkaufen (3000+ Wörter pro Seite)
export const AckerlandVerkaufenPage = lazy(() => import('../pages/AckerlandVerkaufenPage'));
export const WaldVerkaufenPage = lazy(() => import('../pages/WaldVerkaufenPage'));
export const GruenlandVerkaufenPage = lazy(() => import('../pages/GruenlandVerkaufenPage'));
export const WeinbergeVerkaufenPage = lazy(() => import('../pages/WeinbergeVerkaufenPage'));
export const EigenjagdVerkaufenPage = lazy(() => import('../pages/EigenjagdVerkaufenPage'));
export const BauernhoefeVerkaufenPage = lazy(() => import('../pages/BauernhoefeVerkaufenPage'));
export const ReitanlagenVerkaufenPage = lazy(() => import('../pages/ReitanlagenVerkaufenPage'));
export const AgrarflaechenPreisePage = lazy(() => import('../pages/AgrarflaechenPreisePage'));
export const VerkaufsprozessPage = lazy(() => import('../pages/VerkaufsprozessPage'));
export const WarumAgrarKapitalPage = lazy(() => import('../pages/WarumAgrarKapitalPage'));
export const BieterverfahrenPage = lazy(() => import('../pages/BieterverfahrenPage'));
export const SonderkulturenVerkaufenPage = lazy(() => import('../pages/SonderkulturenVerkaufenPage'));
export const KiVorbewertungPage = lazy(() => import('../pages/KiVorbewertungPage'));
export const BiogasPage = lazy(() => import('../pages/BiogasPage'));
export const SolarWindPage = lazy(() => import('../pages/SolarWindPage'));
